<input
  #inputEl
  type="text"
  id="{{ 'question-input-' + question.id }}"
  [formControl]="myFormControl"
  [minlength]="question.minLength"
  [maxlength]="question.maxLength"
  [attr.autofocus]="autofocus"
  (focus)="isFocused = true"
  (blur)="onBlur()"
  [attr.disabled]="disabled"
  [attr.tabindex]="tabIndex"
/>
@if (myFormControl?.errors) {
<div class="clear validation-text">
  @if (myFormControl?.errors?.required) {
  <div>{{ question.question }} {{ "is-required" | transloco }}</div>
  } @if (myFormControl?.errors?.minlength) {
  <div>
    {{ question.question }} {{ "must-be-at-least" | transloco }}
    {{ myFormControl?.errors?.minlength.requiredLength }}
    {{ "characters" | transloco }}
  </div>
  } @if (myFormControl?.errors?.maxlength) {
  <div>
    {{ question.question }} has exceeded maximum
    {{ question.maxLength }} characters
  </div>
  }
</div>
} @if ( myFormControl.value && question.maxLength && myFormControl?.errors ===
null && isFocused ) {
<div
  class="char-count"
  [ngClass]="{ invalid: myFormControl.value.length >= question.maxLength }"
>
  {{ question.maxLength - myFormControl.value.length }}
  {{ "chars-left" | transloco }}
</div>
}
